import { Component, OnInit } from '@angular/core';
import { TbNbs } from '../model/tb-nbs.model';
import { CrudService } from 'app/shared/services/crud.service';
import { DataTableBasicComponent } from 'app/shared/components/data-table/data-table-basic.component';
import { DataTableColumn } from 'app/shared/components/data-table/model/data-table-column.model';
import { DataControl } from 'app/shared/components/data-table/model/data-control.model';

@Component({
  selector: 'siscoserv-nbs',
  templateUrl: './nbs.component.html',
  styleUrls: ['./nbs.component.scss'],
  providers: [CrudService]
})
export class NbsComponent extends DataTableBasicComponent implements OnInit {
  public tbNbs: TbNbs = new TbNbs();

  constructor(crudService: CrudService) {
    super(crudService);
  }

  ngOnInit() {
    this.columns = [
      new DataTableColumn('CÓDIGO', 'cod'),
      new DataTableColumn('DESCRIÇÃO', 'descricao')
    ];

    this.controls = [
      new DataControl('Código', 'cod').setReadOnly(),
      new DataControl('Descrição', 'descricao').setReadOnly()
    ];
  }
}
